<template>
  <v-card>
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="lecturers"
      :items-per-page="50"
      class="elevation-1"
      :search="search"
    >
    </v-data-table>
  </v-card>
</template>
<script>
export default {
  name: "Lecturers",

  data: () => ({
    drawer: null,
    headers: [
      { text: "Prénom", value: "first_name" },
      { text: "Nom", value: "last_name" },
      { text: "Email", value: "email" },
      { text: "Email Personnel", value: "personnal_email" },
    ],
    lecturers: [],
    search: null,
  }),
  methods: {
    loadLecturers() {
      this.axios
        .get("/lecturers", {params: {}})
        .then((response) => (this.lecturers = response["data"]));
    },
  },
  mounted() {
    this.loadLecturers();
  },
};
</script>